export default __webpack_public_path__ + "static/media/logoBoat.8ad864b1.svg";